import React, { useState } from "react";
import { Search, X } from "lucide-react";

function SearchInput({
  placeholder = "Search...",
  onSearch,
  onClear,
  value: controlledValue,
  onChange,
}) {
  const [localQuery, setLocalQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const query = controlledValue !== undefined ? controlledValue : localQuery;

  const handleChange = (e) => {
    const value = e.target.value;
    if (controlledValue === undefined) {
      setLocalQuery(value);
    }
    onChange?.(e);
    onSearch?.(value);
  };

  const handleClear = () => {
    const newValue = "";
    if (controlledValue === undefined) {
      setLocalQuery(newValue);
    }
    onChange?.({ target: { value: newValue } });
    onClear?.();
  };

  return (
    <div className="w-full max-w-md">
      <div
        className={`
          flex items-center gap-3 px-4 py-3 rounded-xl bg-base-100 
          shadow-sm transition-all duration-300 
          ${isFocused ? "shadow-lg ring-2 ring-primary" : "shadow-sm"}
          focus-within:ring-2 focus-within:ring-primary
           border ${
             isFocused
               ? "border-info ring-2 ring-info/40 shadow-md"
               : "border-base-300"
           }
        `}
      >
        <Search className="w-5 h-5 text-base-content/60" strokeWidth={2.5} />

        <input
          type="text"
          placeholder={placeholder}
          value={query}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="
            flex-1 bg-transparent 
            outline-none border-none 
            text-base-content placeholder-base-content/50 
            font-medium 
            focus:ring-0 focus:border-primary
            [-webkit-appearance:none] [appearance:none]
          "
          style={{ boxShadow: "none" }}
        />

        {query && (
          <button
            type="button"
            onClick={handleClear}
            className="
              p-1.5 rounded-full 
              btn btn-primary border-none text-white
              text-base-content/70 hover:text-base-content 
              transition-all duration-200 
              flex items-center justify-center
              focus:outline-none focus:ring-2 focus:ring-primary/50
            "
            aria-label="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}

export default React.memo(SearchInput);
